import { DynamicFormType, DEFAULT_SUB_TYPE } from "../form-field/form-field-type";
import { FormFieldSettingType } from "./form-field-setting";

/**
 * Describes a form field using its type and sub type.
 */
export class SubType {
  constructor(public type: DynamicFormType = DynamicFormType.SINGLE, public subType: string = DEFAULT_SUB_TYPE) {}

  public static of(type: DynamicFormType, subType?: string): SubType {
    return new SubType(type, subType);
  }

  public static toSubType(fieldType: FormFieldSettingType): SubType {
    return fieldType instanceof SubType ? fieldType : SubType.of(fieldType);
  }
}
